<div class="container">
  <elab-register-form (successfulRegisterEmitter)="onSuccessfullyLoggedIn()"></elab-register-form>
</div>
